<template>
  <component :is="isProducer && false? 'DragDiv' : 'div'" class="preview-container" :onDrag="() => toggleToSelectedReleases(true)">
    <li
      ref="releasePreview"
      class="release-preview flex column gap5"
      :class="{ selected_: selectedReleaseIds.includes(item._id) }"
      :style="previewVars"
      @click="handleClick"
    >
      <div ref="releaseImgWrapper" class="release-img-wrapper">
        <img class="release-img" :src="imgSrc" :alt="release.title" loading="lazy">
        <p class="release-date-badge" v-if="badgeDateStr">
          {{ badgeDateStr }}
        </p>
        <div v-if="!isUserOrgWatchOnly && !reportMode" class="actions-container">
          <div class="actions">
            <button
              type="button"
              :title="$t('watch')"
              class="action-icon"
              v-if="isProducer"
              @click.stop="goToLandingPage"
              @mouseenter="hoveredAction = 'eye'"
              @mouseleave="hoveredAction = null"
            >
              <span class="action-icon-svg" v-html="hoveredAction === 'eye' ? cardSvgs.eye : PreviewActionsCard.eye"></span>
            </button>
            <router-link
              :title="$t('edit')"
              class="action-icon"
              v-if="isProducer"
              @mouseenter.native="hoveredAction = 'pencil'"
              @mouseleave.native="hoveredAction = null"
              @click.native.stop
              :to="{ name: 'ReleaseEdit', params: { organizationId: item.organizationId, id: item._id } }"
            >
              <span class="action-icon-svg" v-html="hoveredAction === 'pencil' ? cardSvgs.pencil : PreviewActionsCard.pencil"></span>
            </router-link>
            <router-link
              :title="$t('statsLocales.stat')"
              class="action-icon"
              v-if="isRoleInOrg('admin')"
              @mouseenter.native="hoveredAction = 'stats'"
              @mouseleave.native="hoveredAction = null"
              :to="{ name: 'ReleaseReport', params: { organizationId: item.organizationId, id: item._id } }"
            >
              <span class="action-icon-svg" v-html="hoveredAction === 'stats' ? cardSvgs.statistics : PreviewActionsCard.statistics"></span>
            </router-link>
            <router-link
              :title="$t('distributeLocales.distributeRelease')"
              class="action-icon"
              v-if="isProducer"
              @mouseenter.native="hoveredAction = 'distribute'"
              @mouseleave.native="hoveredAction = null"
              @click.native.stop
              :to="{ name: 'ReleaseDistribution', params: { organizationId: item.organizationId, id: item._id } }"
            >
              <span class="action-icon-svg" v-html="hoveredAction === 'distribute' ? cardSvgs.distribute : PreviewActionsCard.distribute"></span>
            </router-link>
          </div>
        </div>
      </div>
      <p class="release-title">{{release.shortTitle || release.title}}</p>
        <!-- <p class="dist-title align-self-end_" v-if="item.distributedAt">{{$t('releaseLocales.distributedAt')}}: {{pretyDistributionTime}}</p> -->
    </li>
  </component>
</template>

<script>
import DragDiv from '../../common/cmps/dnd/DragDiv.vue';
import { templateUtils } from '../../../../common/modules/common/services/template.util.service';
import evManager from '@/apps/common/modules/common/services/event-emmiter.service.js';
import { fixFileSrcToThumbnail } from '../../../../common/modules/common/services/file.service';
import { organizationService } from '../../organization/services/organization.service';

import { getSvgs, PreviewActionsCard, getPreviewActionsCard } from '../../../assets/images/svgs.js'

import config from '@/config';
import FormInput from '../../../../common/modules/common/cmps/FormInput.vue';
import { Utils } from '../../../../common/modules/common/services/util.service';

export default {
  components: { DragDiv, FormInput },
  name: 'ReleasePreview',
  props: {
    item: {
      type: Object,
      required: true
    },
    itemDetailesPageName: [String],
    selectedReleaseIds: {
      type: Array,
      default: () => []
    },
    reportMode: {
      type: Boolean,
      required: false
    },
  },
  data() {
    return {
      isSelected: false,
      PreviewActionsCard,
      hoveredAction: null,
      cardInlineSizePx: 190,
      cardBlockSizePx: 126,
      cardResizeObserver: null
    }
  },
  created() {
    this.isSelected = this.selectedReleaseIds.includes(this.item._id);
  },
  mounted() {
    this.setupCardResizeObserver()
  },
  beforeDestroy() {
    this.teardownCardResizeObserver()
  },
  computed: {
    // isAdmin() {
    //   return organizationService.isUserRoleInOrg(this.organization._id, 'admin', this.loggedUser);
    //   // return this.$store.getters['auth/isAdmin'];
    // },
    isProducer() {
      return this.isRoleInOrg('producer');
    },
    release() {
      return this.item.releaseData
    },
    organization() {
      return this.$store.getters['organization/selectedItem'];
    },
    imgSrc() {
      return fixFileSrcToThumbnail(this.release.mainImage, this.item)
        ? fixFileSrcToThumbnail(this.release.mainImage, this.item)
        : require('@/apps/megaphonApp/assets/images/image_placeholder.png');
    },

    pretyDistributionTime() {
      if (!this.item.distributedAt) return '';
      return Utils.Time.getTimeStrAs(this.item.distributedAt, 'date/month/year');
      // const time = new Date(this.item.distributedAt);
      // return `${time.getDate()}/${time.getMonth()+1}/${time.getFullYear()}`;
    },
    loggedUser() {
      return this.$store.getters['auth/loggedUser'];
    },
    isUserOrgWatchOnly() {
      // return this.$store.getters['auth/isWatchOnly'];
      return organizationService.isUserWatchOnly(this.organization?._id, this.loggedUser);
    },
    
    selectedTheme() {
      return this.$store.getters['selectedTheme'];
    },

    badgeTimestamp() {
      if (this.reportMode && this.item.distributedAt) {
        return this.item.distributedAt
      }
      if (!this.reportMode && (this.item._createdAt || this.item.createdAt)) {
        return this.item._createdAt || this.item.createdAt
      }
      return null
    },

    badgeDateStr() {
      if (!this.badgeTimestamp) return ''
      return Utils.Time.getTimeStrAs(this.badgeTimestamp, 'date/month/year')
    },

    actionSvgs() {
      const clr = this.selectedTheme?.colors?.[4] || 'black';
      return getSvgs(clr).PreviewActions; 
    },

    cardSvgs() {
      const clr = this.selectedTheme?.colors?.[4] || '#CC0000';
      return getPreviewActionsCard(clr);
    },

    previewVars() {
      return {
        '--card-inline-size': `${this.cardInlineSizePx}px`,
        '--action-size': `${this.responsiveActionSizePx}px`,
        '--action-gap': `${this.responsiveActionGapPx}px`,
        '--actions-offset': `${this.responsiveActionsOffsetPx}px`
      }
    },

    visibleActionsCount() {
      if (this.isUserOrgWatchOnly || this.reportMode) return 0
      let count = 0
      if (this.isProducer) count += 3
      if (this.isRoleInOrg('admin')) count += 1
      return count
    },

    responsiveActionSizePx() {
      const min = 20
      const max = 48
      const baseSize = Math.max(min, Math.min(max, this.cardInlineSizePx * 0.113))
      const baseGap = this.responsiveActionGapBasePx
      const count = this.visibleActionsCount
      if (count <= 0) return baseSize

      // Keep enough room between top actions and bottom date on short cards
      const verticalSafety = 32
      const availableHeight = Math.max(0, this.cardBlockSizePx - verticalSafety)
      const required = count * baseSize + (count - 1) * baseGap
      if (required <= availableHeight || required === 0) return baseSize

      const scale = availableHeight / required
      return Math.max(20, baseSize * scale)
    },

    responsiveActionGapBasePx() {
      const min = 4
      const max = 10
      return Math.max(min, Math.min(max, this.cardInlineSizePx * 0.0235))
    },

    responsiveActionGapPx() {
      const baseGap = this.responsiveActionGapBasePx
      const baseSize = Math.max(20, Math.min(48, this.cardInlineSizePx * 0.113))
      const count = this.visibleActionsCount
      if (count <= 1) return baseGap

      const verticalSafety = 32
      const availableHeight = Math.max(0, this.cardBlockSizePx - verticalSafety)
      const required = count * baseSize + (count - 1) * baseGap
      if (required <= availableHeight || required === 0) return baseGap

      const scale = availableHeight / required
      return Math.max(2, baseGap * scale)
    },

    responsiveActionsOffsetPx() {
      // keep compact on tiny cards, breathe on larger cards
      return Math.max(6, Math.min(12, this.cardInlineSizePx * 0.025))
    }
  },
  methods: {
    setupCardResizeObserver() {
      if (!window.ResizeObserver) return
      const cardEl = this.$refs.releasePreview
      const imageEl = this.$refs.releaseImgWrapper
      if (!cardEl) return

      this.cardResizeObserver = new ResizeObserver(entries => {
        entries?.forEach(entry => {
          if (!entry) return
          const { width, height } = entry.contentRect || {}
          if (entry.target === cardEl && width > 0) this.cardInlineSizePx = Math.round(width)
          if (entry.target === imageEl && height > 0) this.cardBlockSizePx = Math.round(height)
        })
      })
      this.cardResizeObserver.observe(cardEl)
      if (imageEl) this.cardResizeObserver.observe(imageEl)
    },

    teardownCardResizeObserver() {
      if (!this.cardResizeObserver) return
      this.cardResizeObserver.disconnect()
      this.cardResizeObserver = null
    },

    isRoleInOrg(role) {
      return organizationService.isUserRoleInOrg(this.organization?._id, role, this.loggedUser);
    },
    goToLandingPage() {
      if (this.reportMode) {
        this.$router.push({ name: 'ReleaseReport', params: { organizationId: this.item.organizationId, id: this.item._id } })
        return;
      }
      const pageUrl = templateUtils.getReleaseLandingPageUrl(this.item, this.organization, 'landingPage', config, window.location.pathname);
      window.open(pageUrl);
    },
    toggleToSelectedReleases(isDraging = false) {
      // this.isSelected = !this.isSelected;
      evManager.emit('toggleRelease-from-selected', this.item._id, isDraging);
    },

    handleClick() {
      return this.goToLandingPage();
      if (!this.$store.getters.isScreenWide || this.isUserOrgWatchOnly) return this.goToLandingPage();
      this.isProducer? this.toggleToSelectedReleases(false) : this.goToLandingPage();
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/styles/global/index';
.megaphon-app {
  .preview-container {
    @media (max-width: $small-screen-break) {
      width: 100%;
    }
  }
  .release-preview {
    color: var(--clr-0);
    position: relative;
    // width: em(180px);
    @media (max-width: $small-screen-break) {
      // width: 90vw;
      width: 100%;
    }
    --btn-size: #{em(33px)};
    // Cap action icons on very wide/large cards (flex fill otherwise grows without limit)
    --action-btn-max: #{em(48px)};
    cursor: pointer;
    transition: opacity 0.2s ease;
    .release-img-wrapper {
      position: relative;
      width: 100%;
      aspect-ratio: 3 / 2;
      border-radius: em(10px);
      overflow: hidden;
      // --btn-size kept for any other consumers; action buttons use flex fill below
      --btn-size: #{em(28px)};
      &::after {
        content: "";
        position: absolute;
        inset: 0;
        background: linear-gradient(to top, rgba(0, 0, 0, 0.3), transparent 55%);
        opacity: 0;
        transition: opacity 0.2s ease;
        pointer-events: none;
      }
    }
    .release-img {
      display: block;
      width: 100%;
      object-fit: cover;
    }
    @media (max-width: $small-screen-break) {
      // keep original responsive height/aspect-ratio behavior from parent grid
    }
    .dist-title {
      font-size: em(12px);
    }
    p.release-title {
      word-wrap: break-word;
      font-size: em(16px);
      font-weight: 500;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2; // max 2 lines
      -webkit-box-orient: vertical;
      white-space: normal;
    }

    .release-date-badge {
      position: absolute;
      left: var(--actions-offset, #{em(6px)});
      bottom: var(--actions-offset, #{em(6px)});
      padding: 0;
      background: none;
      border-radius: 0;
      color: #ffffff;
      font-size: em(14px);
      font-weight: 400;
      text-shadow: 0 0 em(2px) rgba(0, 0, 0, 0.45);
      z-index: 2;
    }

    // Icons: top-left, responsive size with min/max, date bottom-left
    .actions-container {
      position: absolute;
      top: var(--actions-offset, #{em(6px)});
      left: var(--actions-offset, #{em(6px)});
      right: auto;
      bottom: auto;
      width: auto;
      @media (min-width: $small-screen-break) {
        opacity: 0;
        pointer-events: none;
        transition: opacity 0.2s ease;
      }
      .actions {
        position: relative;
        z-index: 1;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        // gap scales with card width and stays in a safe range
        gap: var(--action-gap, #{em(4px)});
      }
      .action-icon {
        display: block;
        padding: 0;
        margin: 0;
        border: none;
        background: none;
        cursor: pointer;
        line-height: 0;
        text-decoration: none;
        color: inherit;
        // responsive size: ~24px on small cards up to ~48px on large cards
        width: var(--action-size, #{em(20px)});
        height: var(--action-size, #{em(20px)});
        flex-shrink: 0;
        .action-icon-svg {
          display: block;
          width: 100%;
          height: 100%;
          aspect-ratio: 1;
          transition: filter 0.2s ease, opacity 0.2s ease;
          // OFF state: use neutral SVG colors as-is
          filter: none;
        }
        .action-icon-svg svg {
          display: block;
          width: 100%;
          height: 100%;
        }
      }
      a.action-icon {
        -webkit-tap-highlight-color: transparent;
      }
    }

    .select-checkbox {
      position: absolute;
      bottom: 10px;
      inset-inline-start: 10px;
    }

    &.selected {
      outline: em(3px) solid #2771A4;
    }

    @media (min-width: $small-screen-break) {
      &:hover .release-img-wrapper::after {
        opacity: 1;
      }
      &:hover .actions-container {
        opacity: 1;
        pointer-events: auto;
      }
    }
  }
}
</style>